module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/backstage-module/common/add-variant-box/add-variant-box.component.scss
// module id = ./src/app/modules/backstage-module/common/add-variant-box/add-variant-box.component.scss
// module chunks = 9